module.exports = __webpack_public_path__ + "static/media/Quartzo-Bienna.2380ad2d.png";